import _ from "lodash";
import {
    LOGIN,
    LOGOUT,
    SESSION,
    OMNIAUTHLOGIN,
    GET_LICENSE,
    ACCEPT_COOKIES,
} from "./Authentication.action.react";
import { UPDATE_USER } from "app/adminPanels/redux/AdminPanel.action.react";
import { UPDATE_USER_LICENSE } from "app/blog/redux/Blog.action.react";

import { REHYDRATE } from "redux-persist/constants";

const initialAuthState = {
    error: {},
    status: "",
    token: null,
    user: {
        license: {},
        details: {},
        profile: {},
        client: {
            appConfiguration: {},
        },
    },
    isUserLoggedIn: false,
    sessions: [],
};

const AuthenticationReducer = (state = initialAuthState, action) => {
    let newState;
    switch (action.type) {
        case REHYDRATE:
            let auth = action.payload.auth;
            if (auth) {
                return { ...state, ...auth };
            } else {
                return state;
            }
        case LOGIN:
            if (action.status === "authenticating") {
                return { ...state, status: action.status, error: {} };
            } else if (action.status === "success") {
                return {
                    ...state,
                    status: action.status,
                    user: {
                        ...action.data,
                        id: action.data.id,
                    },
                    isUserLoggedIn: true,
                    error: {},
                };
            } else if (action.status === "error")
                return { ...state, status: action.status, error: action.err };
            else {
                return state;
            }
        case LOGOUT:
            if (action.status === "authenticating") {
                return { ...state, status: action.status, error: {} };
            } else if (action.status === "success") {
                return {
                    ...state,
                    status: action.status,
                    user: null,
                    isUserLoggedIn: false,
                    error: {},
                };
            } else if (action.status === "error")
                return {
                    ...state,
                    status: action.status,
                    user: null,
                    isUserLoggedIn: false,
                    error: action.err,
                };
            else {
                return state;
            }
        case SESSION:
            let sessions = [...state.sessions];
            let startTime = new Date().getTime();
            let sessionId = 0;
            const userId = state.user.id;
            if (sessions.length) {
                let lastSession = _.pullAt(sessions, sessions.length - 1);
                lastSession.isActive = false;
                lastSession.endTime = startTime;
                sessions.push(lastSession);
                sessionId = _.replace(lastSession.sessionId, userId, "");
            }
            let sessionData = {
                sessionId: userId + sessionId,
                userId: userId,
                startTime: startTime,
                isActive: true,
                endTime: undefined,
            };
            sessions.push(sessionData);
            return { ...state, sessions: sessions };
        case OMNIAUTHLOGIN:
            if (action.status === "success") {
                return {
                    ...state,
                    status: action.status,
                    user: {
                        ...action.data,
                        id: action.data.id,
                    },
                    isUserLoggedIn: true,
                    error: {},
                };
            } else {
                return state;
            }
        case GET_LICENSE:
            newState = _.cloneDeep(state);
            newState.user.license = Object.assign(
                {},
                newState.user.license,
                action.data.license
            );
            return newState;
        case ACCEPT_COOKIES:
            if (action.status === "success") {
                return { ...state, ...action.data };
            } else {
                return state;
            }
        case UPDATE_USER:
            return {
                ...state,
                user: Object.assign({}, state.user, {
                    first_name: action.data.first_name,
                    last_name: action.data.last_name,
                    email: action.data.email,
                    profile: action.data.profile,
                    license: action.data.license,
                    image: action.data.image,
                    logo: action.data.logo,
                }),
            };
        case UPDATE_USER_LICENSE:
            return {
                ...state,
                user: Object.assign({}, state.user, {
                    license: action.data.license,
                }),
            };

        default:
            return state;
    }
};

export { AuthenticationReducer };
